module.exports = __webpack_public_path__ + "static/media/Alexander-Lettering.e4e5940e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alexander-Lettering.eot
// module id = 2777
// module chunks = 51